module.exports = __webpack_public_path__ + "static/media/upstate-sm.28cb5b8d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/upstate-sm.svg
// module id = 360
// module chunks = 0